import { createSlice } from "@reduxjs/toolkit";
import { CONNECTION_ID_UPDATED, COMMITMENTPACING_ASOFDATE_CHANGED, subscribeToMessageBus, WIDGET_CONTEXT_UPDATED, COMMITMENTPACING_ASOFDATE_KEY } from "common/ins-message-bus";
const initialState = {};
const slice = createSlice({
    initialState,
    name: "otherModulesDataReducers",
    reducers: {
        updateOtherModulesData: (state, action) => {
            const { key, value } = action.payload;
            state[key] = value;
        }
    }
});
subscribeToMessageBus(WIDGET_CONTEXT_UPDATED, (data) => {
    const actions = [];
    if (data.context?.objective !== undefined) {
        actions.push(slice.actions.updateOtherModulesData({ key: `${data.entityType}/${data.entityId}/objective`, value: data.context.objective }));
    }
    if (data.context?.pacingPlanObjective !== undefined) {
        actions.push(slice.actions.updateOtherModulesData({ key: `${data.entityType}/${data.entityId}/pacingPlanObjective`, value: data.context.pacingPlanObjective }));
    }
    return { actions };
});
subscribeToMessageBus(CONNECTION_ID_UPDATED, (id) => ({
    actions: [slice.actions.updateOtherModulesData({ key: "operationNotificationConnectionId", value: id })]
}));
subscribeToMessageBus(COMMITMENTPACING_ASOFDATE_CHANGED, (date) => ({
    actions: [slice.actions.updateOtherModulesData({ key: COMMITMENTPACING_ASOFDATE_KEY, value: date })]
}));
export const otherModulesDataReducers = slice.reducer;
export const { updateOtherModulesData } = slice.actions;
